import React from 'react';
import { Result, Button } from 'antd';

const Error404M = () => (
  <Result
    status="404"
    title="404"
    subTitle="對不起，您訪問的頁面不存在。"
  />
);

export default Error404M;
